import './dashboard.scss';
import 'flatpickr/dist/flatpickr.min.css';

const PAL = ['#5b4fcf','#0d9488','#d97706','#ef4444','#06b6d4','#8b5cf6','#ec4899'];

function destroyChart(el) {
  if (el && el._chartInstance) { el._chartInstance.destroy(); el._chartInstance = null; }
}

function initAdvPreview(prefix, mediaUrl, slideUrl) {
  var loadingEl  = document.getElementById(prefix + 'PreviewLoading');
  if (!loadingEl) return;
  if (loadingEl.dataset.previewInit) return;
  loadingEl.dataset.previewInit = '1';

  var overlayEl  = document.getElementById(prefix + 'PlayOverlay');
  var slotA      = document.getElementById(prefix + 'SlideA');
  var slotB      = document.getElementById(prefix + 'SlideB');
  var infoBar    = document.getElementById(prefix + 'PreviewInfoBar');
  var nameEl     = document.getElementById(prefix + 'PreviewName');
  var subEl      = document.getElementById(prefix + 'PreviewSub');
  var dotsEl     = document.getElementById(prefix + 'PreviewDots');
  var labelEl    = document.getElementById(prefix + 'PreviewLabel');
  var progressEl = document.getElementById(prefix + 'PreviewProgress');
  var fsIcon     = document.getElementById(prefix + 'FsIcon');
  var fsScreen   = document.getElementById(prefix + 'PreviewScreen');

  var SLIDE_DURATION = 5000;
  var slides = [], current = 0, playing = false;
  var timer = null, progressTimer = null, progressStart = null, activeSlot = 'A';
  var urlCache = {};

  fetch(mediaUrl)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      slides = data;
      buildDots();
      if (slides.length === 0) {
        loadingEl.innerHTML = '<div style="font-size:11px;color:#6b7280;">No contents</div>';
        return;
      }
      loadingEl.style.display = 'none';
      renderIntoSlot(slotA, slides[0], null);
      slotA.style.transition = 'none';
      slotA.style.opacity = '1';
      activeSlot = 'B';
      labelEl.textContent = slides.length + ' content' + (slides.length === 1 ? '' : 's');
      updateDots(0);
    })
    .catch(function() {
      loadingEl.innerHTML = '<div style="font-size:11px;color:#6b7280;">Preview unavailable</div>';
    });

  function fetchSlideUrl(idx) {
    var slide = slides[idx];
    if (!slide) return Promise.resolve(null);
    if (urlCache[slide.content_id]) return Promise.resolve(urlCache[slide.content_id]);
    return fetch(slideUrl + '?content_id=' + slide.content_id)
      .then(function(r) { return r.json(); })
      .then(function(d) { urlCache[slide.content_id] = d; return d; })
      .catch(function() { return { url: null, mime_type: null }; });
  }

  function buildDots() {
    dotsEl.innerHTML = '';
    slides.forEach(function(_, i) {
      var d = document.createElement('span');
      d.id = prefix + 'dot-' + i;
      d.style.cssText = 'display:inline-block;width:5px;height:5px;border-radius:50%;background:rgba(255,255,255,.25);cursor:pointer;transition:all .2s;';
      d.onclick = function() { window[prefix + 'PreviewJump'](i); };
      dotsEl.appendChild(d);
    });
  }

  function updateDots(idx) {
    document.querySelectorAll('[id^="' + prefix + 'dot-"]').forEach(function(d, i) {
      d.style.background = i === idx ? '#5b4fcf' : 'rgba(255,255,255,.25)';
      d.style.width = i === idx ? '14px' : '5px';
      d.style.borderRadius = '3px';
    });
  }

  function renderIntoSlot(slot, slide, urlData) {
    var viewerData = urlData && urlData.viewer_data;

    if (viewerData) {
      var iframe = slot.querySelector('iframe[data-viewer]');
      if (!iframe) {
        var wasPlaying = playing;
        if (wasPlaying) {
          clearTimeout(timer);
          clearInterval(progressTimer);
          progressEl.style.width = '0%';
        }
        slot.innerHTML = '';
        iframe = document.createElement('iframe');
        iframe.setAttribute('data-viewer', '1');
        iframe.style.cssText = 'width:100%;height:100%;border:0;background:#000;';
        iframe.src = '/viewer/index.html?width=1920&height=1080&onlyPreview=false';
        iframe.addEventListener('load', function() {
          iframe._loaded = true;
          if (iframe._pending) {
            try { iframe.contentWindow.postMessage(iframe._pending, '*'); } catch (e) {}
            iframe._pending = null;
          }
          if (wasPlaying && playing) {
            setTimeout(function() {
              if (!playing) return;
              startProgress();
              startTimer();
            }, 300);
          }
        });
        slot.appendChild(iframe);
      }
      if (iframe._loaded) {
        try { iframe.contentWindow.postMessage(viewerData, '*'); } catch (e) {}
      } else {
        iframe._pending = viewerData;
      }
      return;
    }

    slot.innerHTML = '';
    var url = urlData && urlData.url, mime = urlData && urlData.mime_type, el;
    if (url && /^video\//.test(mime)) {
      el = document.createElement('video');
      el.src = url; el.autoplay = true; el.muted = true; el.loop = false; el.playsInline = true;
      if (playing) {
        clearTimeout(timer);
        clearInterval(progressTimer);
        progressEl.style.width = '0%';
      }
      el.addEventListener('timeupdate', function() {
        if (el.duration && isFinite(el.duration)) {
          progressEl.style.width = (el.currentTime / el.duration * 100) + '%';
        }
      });
      el.addEventListener('ended', function() {
        if (!playing) return;
        clearTimeout(timer);
        var nextIdx = current + 1;
        if (nextIdx >= slides.length) {
          stopPreviewToStart();
        } else {
          showSlide(nextIdx, false);
          startTimer();
        }
      });
    } else if (url && /^image\//.test(mime)) {
      el = document.createElement('img');
      el.src = url;
    } else {
      el = document.createElement('div');
      el.style.cssText = 'width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:linear-gradient(135deg,' + slide.color + 'dd,' + slide.color + '55);';
      el.innerHTML = '<div style="font-size:56px;font-weight:900;color:rgba(255,255,255,.88);line-height:1;">' + (slide.name[0] || '?').toUpperCase() + '</div>'
                   + '<div style="font-size:10px;color:rgba(255,255,255,.4);margin-top:6px;letter-spacing:1px;">NO MEDIA</div>';
      slot.appendChild(el); return;
    }
    el.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    slot.appendChild(el);
  }

  function showSlide(idx, instant) {
    var slide = slides[idx]; if (!slide) return;
    current = idx;
    nameEl.textContent = slide.name;
    subEl.textContent  = (idx + 1) + ' of ' + slides.length;
    infoBar.style.display = 'block';
    labelEl.textContent = (idx + 1) + ' / ' + slides.length;
    updateDots(idx);
    if (playing) startProgress();
    fetchSlideUrl(idx).then(function(urlData) {
      var incoming = activeSlot === 'A' ? slotB : slotA;
      var outgoing = activeSlot === 'A' ? slotA : slotB;
      var oldVideo = outgoing.querySelector('video');
      if (oldVideo) { try { oldVideo.pause(); oldVideo.currentTime = 0; } catch (e) {} }
      renderIntoSlot(incoming, slide, urlData);
      incoming.style.transition = instant ? 'none' : 'opacity .6s ease';
      outgoing.style.transition  = instant ? 'none' : 'opacity .6s ease';
      incoming.style.opacity = '1'; outgoing.style.opacity = '0';
      activeSlot = activeSlot === 'A' ? 'B' : 'A';
      var next = (idx + 1) % slides.length;
      if (next !== idx) fetchSlideUrl(next);
    });
  }

  function startProgress() {
    clearInterval(progressTimer);
    progressEl.style.width = '0%';
    progressStart = Date.now();
    progressTimer = setInterval(function() {
      progressEl.style.width = Math.min((Date.now() - progressStart) / SLIDE_DURATION * 100, 100) + '%';
    }, 80);
  }

  function startTimer() {
    clearTimeout(timer);
    timer = setTimeout(function() {
      if (!playing) return;
      var nextIdx = current + 1;
      if (nextIdx >= slides.length) {
        stopPreviewToStart();
        return;
      }
      showSlide(nextIdx, false);
      startTimer();
    }, SLIDE_DURATION);
  }

  function stopTimer() { clearTimeout(timer); clearInterval(progressTimer); }

  function pauseAllVideos() {
    [slotA, slotB].forEach(function(s) {
      var v = s.querySelector('video');
      if (v) { try { v.pause(); v.currentTime = 0; } catch (e) {} }
    });
  }

  function stopPreviewToStart() {
    playing = false;
    stopTimer();
    pauseAllVideos();
    current = 0;
    progressEl.style.width = '0%';
    overlayEl.style.display = 'flex';
  }

  window[prefix + 'PreviewStart'] = function() {
    if (!slides.length) return;
    overlayEl.style.display = 'none';
    playing = true;
    showSlide(current, false); startTimer();
  };
  window[prefix + 'PreviewNext']   = function() { stopTimer(); showSlide((current + 1) % slides.length, false); if (playing) startTimer(); };
  window[prefix + 'PreviewPrev']   = function() { stopTimer(); showSlide((current - 1 + slides.length) % slides.length, false); if (playing) startTimer(); };
  window[prefix + 'PreviewJump']   = function(i) { stopTimer(); showSlide(i, false); if (playing) startTimer(); };
  window[prefix + 'PreviewFullscreen'] = function() {
    if (!document.fullscreenElement) {
      (fsScreen.requestFullscreen || fsScreen.webkitRequestFullscreen || fsScreen.mozRequestFullScreen).call(fsScreen);
    } else {
      (document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen).call(document);
    }
  };
  document.addEventListener('fullscreenchange', function() {
    if (fsIcon) fsIcon.className = document.fullscreenElement ? 'fas fa-compress' : 'fas fa-expand';
  });
}

window.headContentChanged = function() {
  var drop        = document.getElementById('headContentDropdown');
  var label       = document.getElementById('headContentLabel');
  var selectAllCb = document.getElementById('headContentSelectAll');
  if (!drop || !label) return;
  var all     = Array.from(drop.querySelectorAll('input.content-cb'));
  var checked = all.filter(function(inp) { return inp.checked; });
  label.textContent = checked.length > 0
    ? checked.length + ' content' + (checked.length > 1 ? 's' : '') + ' selected'
    : '— All Contents in Tag —';
  if (selectAllCb) selectAllCb.checked = all.length > 0 && checked.length === all.length;
};

window.headContentSelectAll = function(cb) {
  var drop = document.getElementById('headContentDropdown');
  if (!drop) return;
  drop.querySelectorAll('input.content-cb').forEach(function(inp) { inp.checked = cb.checked; });
  window.headContentChanged();
};

window.headContentToggle = function(e) {
  e.stopPropagation();
  var drop = document.getElementById('headContentDropdown');
  if (!drop) return;
  drop.style.display = drop.style.display === 'none' ? 'block' : 'none';
};

window.headTagToggle = function(e) {
  e.stopPropagation();
  var drop = document.getElementById('headTagDropdown');
  if (!drop) return;
  drop.style.display = drop.style.display === 'none' ? 'block' : 'none';
};

window.headUserChanged = function() {
  var sel    = document.getElementById('headUserSelect');
  if (!sel) return;
  var userId = sel.value;

  var tagDrop  = document.getElementById('headTagDropdown');
  var tagLabel = document.getElementById('headTagLabel');
  var tagAll   = document.getElementById('headTagSelectAll');
  if (tagLabel) tagLabel.textContent = '— All Tags —';
  if (tagAll)   tagAll.checked = false;

  var contDrop  = document.getElementById('headContentDropdown');
  var contLabel = document.getElementById('headContentLabel');
  if (contLabel) contLabel.textContent = '— All Contents in Tag —';
  if (contDrop)  contDrop.innerHTML = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">Select a tag first</div>';

  if (!userId) {
    if (tagDrop) tagDrop.innerHTML = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">Select a user first</div>';
    return;
  }

  var url = sel.dataset.tagsUrl;
  if (tagDrop) tagDrop.innerHTML = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">Loading…</div>';

  fetch(url + '?advertiser_user_id=' + encodeURIComponent(userId), { headers: { Accept: 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(tags) {
      var html;
      if (tags.length === 0) {
        html = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">No tags assigned to this user</div>';
      } else {
        html = '<label style="display:flex;align-items:center;gap:8px;padding:7px 12px;cursor:pointer;font-size:12px;font-weight:600;color:#5b4fcf;border-bottom:1px solid #f0f2f5;margin:0;"'
          + ' onmouseover="this.style.background=\'#f8fafc\'" onmouseout="this.style.background=\'\'">'
          + '<input type="checkbox" id="headTagSelectAll" onchange="window.headTagSelectAll(this)" style="accent-color:#5b4fcf;cursor:pointer;"> Select All</label>';
        tags.forEach(function(t) {
          html += '<label style="display:flex;align-items:center;gap:8px;padding:7px 12px;cursor:pointer;font-size:13px;color:#1e293b;margin:0;"'
            + ' onmouseover="this.style.background=\'#f8fafc\'" onmouseout="this.style.background=\'\'">'
            + '<input type="checkbox" class="tag-cb" name="tag_ids[]" value="' + t.id + '"'
            + ' onchange="window.headTagChanged()" style="accent-color:#5b4fcf;cursor:pointer;"> ' + t.name + '</label>';
        });
      }
      var d = document.getElementById('headTagDropdown');
      if (d) d.innerHTML = html;
    });
};

window.headTagSelectAll = function(cb) {
  var drop = document.getElementById('headTagDropdown');
  if (!drop) return;
  drop.querySelectorAll('input.tag-cb').forEach(function(inp) { inp.checked = cb.checked; });
  window.headTagChanged();
};

window.headTagChanged = function() {
  var tagDrop      = document.getElementById('headTagDropdown');
  var tagLabel     = document.getElementById('headTagLabel');
  var tagSelectAll = document.getElementById('headTagSelectAll');
  if (!tagDrop || !tagLabel) return;

  var allTags     = Array.from(tagDrop.querySelectorAll('input.tag-cb'));
  var checkedTags = allTags.filter(function(inp) { return inp.checked; });

  tagLabel.textContent = checkedTags.length > 0
    ? checkedTags.length + ' tag' + (checkedTags.length > 1 ? 's' : '') + ' selected'
    : '— All Tags —';
  if (tagSelectAll) tagSelectAll.checked = allTags.length > 0 && checkedTags.length === allTags.length;

  var contDrop  = document.getElementById('headContentDropdown');
  var contLabel = document.getElementById('headContentLabel');
  if (contLabel) contLabel.textContent = '— All Contents in Tag —';

  if (checkedTags.length === 0) {
    if (contDrop) contDrop.innerHTML = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">Select a tag first</div>';
    return;
  }

  if (contDrop) contDrop.innerHTML = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">Loading…</div>';

  var multiEl = document.getElementById('headTagMulti');
  var url     = multiEl ? multiEl.dataset.contentsUrl : '';
  var qs      = checkedTags.map(function(inp) { return 'tag_ids[]=' + encodeURIComponent(inp.value); }).join('&');

  fetch(url + '?' + qs, { headers: { Accept: 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var seen = {};
      var html = '<label style="display:flex;align-items:center;gap:8px;padding:7px 12px;cursor:pointer;font-size:12px;font-weight:600;color:#5b4fcf;border-bottom:1px solid #f0f2f5;margin:0;"'
        + ' onmouseover="this.style.background=\'#f8fafc\'" onmouseout="this.style.background=\'\'">'
        + '<input type="checkbox" id="headContentSelectAll" onchange="window.headContentSelectAll(this)" style="accent-color:#5b4fcf;cursor:pointer;"> Select All</label>';
      data.forEach(function(c) {
        if (seen[c.id]) return;
        seen[c.id] = true;
        html += '<label style="display:flex;align-items:center;gap:8px;padding:7px 12px;cursor:pointer;font-size:13px;color:#1e293b;margin:0;"'
          + ' onmouseover="this.style.background=\'#f8fafc\'" onmouseout="this.style.background=\'\'">'
          + '<input type="checkbox" class="content-cb" name="content_ids[]" value="' + c.id + '"'
          + ' onchange="window.headContentChanged()" style="accent-color:#5b4fcf;cursor:pointer;"> ' + c.name + '</label>';
      });
      if (data.length === 0) {
        html = '<div style="padding:12px;font-size:12px;color:#9097b1;text-align:center;">No contents for selected tags</div>';
      }
      var d = document.getElementById('headContentDropdown');
      if (d) d.innerHTML = html;
    });
};

function onDocClickContentDrop(e) {
  var cMulti = document.getElementById('headContentMulti');
  if (!cMulti || cMulti.contains(e.target)) return;
  var drop = document.getElementById('headContentDropdown');
  if (drop) drop.style.display = 'none';
}

function onDocClickTagDrop(e) {
  var tMulti = document.getElementById('headTagMulti');
  if (!tMulti || tMulti.contains(e.target)) return;
  var drop = document.getElementById('headTagDropdown');
  if (drop) drop.style.display = 'none';
}

function initHeadTagMulti() {
  var tagMulti = document.getElementById('headTagMulti');
  if (!tagMulti) return;
  if (tagMulti.dataset.initDone) return;
  tagMulti.dataset.initDone = '1';

  document.removeEventListener('click', onDocClickContentDrop);
  document.addEventListener('click', onDocClickContentDrop);
  document.removeEventListener('click', onDocClickTagDrop);
  document.addEventListener('click', onDocClickTagDrop);

  window.headContentChanged();

  var tagDrop      = document.getElementById('headTagDropdown');
  var tagSelectAll = document.getElementById('headTagSelectAll');
  if (tagDrop && tagSelectAll) {
    var allTags     = Array.from(tagDrop.querySelectorAll('input.tag-cb'));
    var checkedTags = allTags.filter(function(inp) { return inp.checked; });
    tagSelectAll.checked = allTags.length > 0 && checkedTags.length === allTags.length;
  }
}

function fmtDate(d) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

function parseISO(value) {
  return value ? new Date(value + 'T00:00:00') : null;
}

function initHeadDatePicker() {
  var startEl = document.getElementById('headStartPicker');
  var endEl   = document.getElementById('headEndPicker');
  if (!startEl || !endEl || !window.flatpickr) return;
  if (startEl.dataset.fpInit) return;
  startEl.dataset.fpInit = '1';

  var startHidden = document.getElementById('headStartDate');
  var endHidden   = document.getElementById('headEndDate');

  var endFp = flatpickr(endEl, {
    dateFormat: 'd M Y',
    maxDate: 'today',
    defaultDate: parseISO(endEl.dataset.value),
    onChange: function(dates) {
      if (dates.length) endHidden.value = fmtDate(dates[0]);
    }
  });

  flatpickr(startEl, {
    dateFormat: 'd M Y',
    maxDate: 'today',
    defaultDate: parseISO(startEl.dataset.value),
    onChange: function(dates) {
      if (dates.length) {
        startHidden.value = fmtDate(dates[0]);
        endFp.set('minDate', dates[0]);
      }
    }
  });

  var form = document.getElementById('headDashForm');
  if (form && !form.dataset.dateValidationBound) {
    form.dataset.dateValidationBound = '1';

    var errEl = document.getElementById('headDateError');
    if (!errEl) {
      errEl = document.createElement('div');
      errEl.id = 'headDateError';
      errEl.style.cssText = 'display:none;color:#ef4444;font-size:11px;font-weight:600;margin-top:5px;';
      errEl.textContent = 'Please select both start and end dates.';
      startEl.parentNode.appendChild(errEl);
    }

    var hideErr = function() {
      errEl.style.display = 'none';
      startEl.style.border = '1px solid #e2e8f0';
      endEl.style.border   = '1px solid #e2e8f0';
    };
    [startEl, endEl].forEach(function(el) {
      el.addEventListener('focus', hideErr);
      el.addEventListener('input', hideErr);
    });

    form.addEventListener('submit', function(e) {
      var startFp = startEl._flatpickr;
      if (startFp && startFp.selectedDates.length) startHidden.value = fmtDate(startFp.selectedDates[0]);
      if (endFp   && endFp.selectedDates.length)   endHidden.value   = fmtDate(endFp.selectedDates[0]);

      if (!startHidden.value || !endHidden.value || startHidden.value === endHidden.value) {
        e.preventDefault();
        errEl.textContent = !startHidden.value || !endHidden.value
          ? 'Please select both start and end dates.'
          : 'Please select an end date different from the start date.';
        errEl.style.display = 'block';
        startEl.style.border = '1px solid #ef4444';
        endEl.style.border   = '1px solid #ef4444';
        return false;
      }
      hideErr();
    });
  }
}

window.startInvoiceDownload = function(e, link) {
  e.preventDefault();
  var token   = 'inv_' + Date.now();
  var overlay = document.getElementById('pdfGenOverlay');
  if (overlay) overlay.style.display = 'flex';
  window.location.href = link.href + (link.href.indexOf('?') === -1 ? '?' : '&') + 'download_token=' + token;
  var cookieName = 'pdf_ready_' + token;
  var elapsed    = 0;
  var poll = setInterval(function() {
    elapsed += 600;
    if (document.cookie.indexOf(cookieName + '=1') !== -1) {
      clearInterval(poll);
      if (overlay) overlay.style.display = 'none';
      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    } else if (elapsed > 120000) {
      clearInterval(poll);
      if (overlay) overlay.style.display = 'none';
    }
  }, 600);
};

function initAdvertiseDashboard() {
  if (!document.getElementById('adv-dashboard') && !document.getElementById('adv-head-dashboard')) return;

  var lineEl = document.getElementById('lineChart');
  if (lineEl) {
    destroyChart(lineEl);
    var lLabels = JSON.parse(lineEl.dataset.labels);
    var lVals   = JSON.parse(lineEl.dataset.values);
    var lAvg    = lVals.length ? lVals.reduce(function(a,b){return a+b;},0)/lVals.length : 0;
    lineEl._chartInstance = new Chart(lineEl, {
      type: 'line',
      data: {
        labels: lLabels,
        datasets: [
          { label: 'Plays', data: lVals, borderColor: '#5b4fcf', backgroundColor: 'rgba(91,79,207,0.08)', borderWidth: 2, pointRadius: 3, pointBackgroundColor: '#5b4fcf', fill: true, tension: 0.35 },
          { label: 'Avg',   data: lVals.map(function(){ return Math.round(lAvg); }), borderColor: '#c4b5fd', borderWidth: 2, borderDash: [6,4], pointRadius: 0, tension: 0, fill: false }
        ]
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: { legend: { display: false }, tooltip: { backgroundColor: '#12111f', titleColor: '#9097b1', bodyColor: '#fff', padding: 10, cornerRadius: 8 } },
        scales: {
          x: { grid: { display: false }, border: { display: false }, ticks: { color: '#9097b1', font: { size: 10 }, maxRotation: 45, autoSkip: true, maxTicksLimit: 10 } },
          y: { display: true, beginAtZero: true, min: 0, grid: { color: '#f0f1f6' }, border: { display: false }, ticks: { color: '#9097b1', font: { size: 11 }, maxTicksLimit: 5, callback: function(val) { return Math.round(val); } } }
        }
      }
    });
  }

  var barEl = document.getElementById('barChart');
  if (barEl) {
    destroyChart(barEl);
    var bNames = JSON.parse(barEl.dataset.names);
    var bVals  = JSON.parse(barEl.dataset.values);
    var h = Math.max(bNames.length * 44 + 60, 180);
    document.getElementById('barWrap').style.height = h + 'px';
    barEl._chartInstance = new Chart(barEl, {
      type: 'bar',
      data: { labels: bNames, datasets: [{ label: 'Plays', data: bVals, backgroundColor: bNames.map(function(_, i){ return PAL[i % PAL.length]; }), borderRadius: 4, borderSkipped: false }] },
      options: {
        indexAxis: 'y', responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { backgroundColor: '#12111f', bodyColor: '#fff', padding: 10, cornerRadius: 8 } },
        scales: {
          x: { beginAtZero: true, grid: { color: '#f0f1f6' }, border: { display: false }, ticks: { color: '#9097b1', font: { size: 10 } } },
          y: { grid: { display: false }, border: { display: false }, ticks: { color: '#374151', font: { size: 11 } } }
        }
      }
    });
  }

  var peakEl = document.getElementById('peakChart');
  if (peakEl) {
    destroyChart(peakEl);
    var phHours = JSON.parse(peakEl.dataset.hours);
    var phVals  = JSON.parse(peakEl.dataset.values);
    var phMax   = Math.max.apply(null, phVals) || 1;
    peakEl._chartInstance = new Chart(peakEl, {
      type: 'bar',
      data: {
        labels: phHours.map(function(h) { var s = h >= 12 ? 'PM' : 'AM'; return (h % 12 || 12) + s; }),
        datasets: [{ label: 'Plays', data: phVals, backgroundColor: phVals.map(function(v) { return 'rgba(91,79,207,' + (0.25 + 0.75 * v / phMax).toFixed(2) + ')'; }), borderRadius: 3, borderSkipped: false }]
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { backgroundColor: '#12111f', bodyColor: '#fff', padding: 10, cornerRadius: 8 } },
        scales: {
          x: { grid: { display: false }, border: { display: false }, ticks: { color: '#9097b1', font: { size: 9 }, maxRotation: 0, autoSkip: true, maxTicksLimit: 12 } },
          y: { beginAtZero: true, grid: { color: '#f0f1f6' }, border: { display: false }, ticks: { color: '#9097b1', font: { size: 10 }, maxTicksLimit: 4, callback: function(v) { return Math.round(v); } } }
        }
      }
    });
  }

  var donutEl = document.getElementById('donutChart');
  if (donutEl) {
    destroyChart(donutEl);
    var dNames = JSON.parse(donutEl.dataset.names);
    var dVals  = JSON.parse(donutEl.dataset.values);
    var dTotal = dVals.reduce(function(a,b){return a+b;},0) || 1;
    donutEl._chartInstance = new Chart(donutEl, {
      type: 'doughnut',
      data: { labels: dNames, datasets: [{ data: dVals, backgroundColor: PAL.slice(0, dVals.length), borderWidth: 0, hoverOffset: 6 }] },
      options: { responsive: true, maintainAspectRatio: false, cutout: '65%', plugins: { legend: { display: false }, tooltip: { backgroundColor: '#12111f', bodyColor: '#fff', padding: 10, cornerRadius: 8 } } }
    });
    var leg = document.getElementById('donutLegend');
    if (leg) {
      leg.innerHTML = '';
      dNames.forEach(function(name, i) {
        var pct = Math.round(dVals[i] / dTotal * 100);
        var row = document.createElement('div'); row.className = 'adv-dl-row';
        row.innerHTML = '<span class="adv-dl-dot" style="background:' + PAL[i % PAL.length] + '"></span>'
          + '<span class="adv-dl-name">' + name + '</span>'
          + '<span class="adv-dl-pct">' + pct + '%</span>';
        leg.appendChild(row);
      });
    }
  }

  document.querySelectorAll('[data-preview-prefix]').forEach(function(el) {
    if (el.dataset.previewInit) return;
    el.dataset.previewInit = '1';
    initAdvPreview(el.dataset.previewPrefix, el.dataset.mediaUrl, el.dataset.slideUrl);
  });

  initHeadTagMulti();
  initHeadDatePicker();
}

function initDateRangePicker() {
  var startEl    = document.getElementById('advStartPicker');
  var endEl      = document.getElementById('advEndPicker');
  var form       = document.getElementById('dateRangeForm');
  var startInput = document.getElementById('startDateInput');
  var endInput   = document.getElementById('endDateInput');
  if (!startEl || !endEl || !form || !window.flatpickr) return;
  if (startEl.dataset.fpInit) return;
  startEl.dataset.fpInit = '1';

  var endFp = flatpickr(endEl, {
    dateFormat: 'd M Y',
    maxDate: 'today',
    defaultDate: parseISO(endEl.dataset.value),
    onChange: function(dates) {
      if (dates.length) {
        endInput.value = fmtDate(dates[0]);
        form.submit();
      }
    }
  });

  flatpickr(startEl, {
    dateFormat: 'd M Y',
    maxDate: 'today',
    defaultDate: parseISO(startEl.dataset.value),
    onChange: function(dates) {
      if (dates.length) {
        startInput.value = fmtDate(dates[0]);
        endFp.set('minDate', dates[0]);
        form.submit();
      }
    }
  });
}

document.addEventListener('turbo:load',      function() { initAdvertiseDashboard(); initDateRangePicker(); });
document.addEventListener('DOMContentLoaded', function() { initAdvertiseDashboard(); initDateRangePicker(); });

(function() {
  var _resizeTimer  = null;
  var _attached     = false;
  var _lastRatio    = window.devicePixelRatio;

  function reInitCharts() {
    ['lineChart', 'barChart', 'peakChart', 'donutChart'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el && el._chartInstance) { el._chartInstance.destroy(); el._chartInstance = null; }
    });
    initAdvertiseDashboard();
  }

  function onResize() {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(function() {
      var newRatio = window.devicePixelRatio;
      if (newRatio !== _lastRatio) {
        _lastRatio = newRatio;
        reInitCharts();
      } else {
        ['lineChart', 'barChart', 'peakChart', 'donutChart'].forEach(function(id) {
          var el = document.getElementById(id);
          if (el && el._chartInstance) el._chartInstance.resize();
        });
      }
    }, 200);
  }

  function attach() {
    if (_attached) return;
    _attached = true;
    window.addEventListener('resize', onResize);
  }

  document.addEventListener('turbo:load',       attach);
  document.addEventListener('DOMContentLoaded', attach);
})();
